import React, { useState } from 'react';
import './LoginSignup.css';

const LoginSignup: React.FC = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [isNotRobot, setIsNotRobot] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.email || !formData.password) return;
    if (!isLogin && (!agreeToTerms || !isNotRobot)) return;

    setIsLoading(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setIsLoading(false);
    // Handle success/error states here
  };

  const handleSocialLogin = (provider: string) => {
    console.log(`${isLogin ? 'Login' : 'Sign up'} with ${provider}`);
    // Implement social login/signup
  };

  return (
    <div className="login-signup-container">
      <div className="login-signup-content">
        <div className="login-signup-header">
          <div className="nrtr-logo">
            <img src="/nrtr-logo-circle.png" alt="NRTR" />
          </div>
          <h1 className="main-title">
            {isLogin ? 'Welcome back to NRTR' : 'Sign up to harness your network'}
          </h1>
        </div>

        <div className="social-buttons">
          <button 
            className="social-button facebook"
            onClick={() => handleSocialLogin('Facebook')}
          >
            <div className="social-icon facebook-icon">
              <svg width="12" height="22" viewBox="0 0 12 22" fill="none">
                <path d="M12 11.0611H8.16667V22H3.83333V11.0611H0V7.44444H3.83333V4.74074C3.83333 1.93519 5.71759 0 8.45833 0C9.79167 0 11.1667 0.259259 11.1667 0.259259V3.96296H9.65278C8.16667 3.96296 7.69444 4.84815 7.69444 5.76296V7.44444H11.0278L10.4722 11.0611H7.69444H8.16667Z" fill="white"/>
              </svg>
            </div>
            <span>{isLogin ? 'Continue with Facebook' : 'Sign up with Facebook'}</span>
          </button>

          <button 
            className="social-button google"
            onClick={() => handleSocialLogin('Google')}
          >
            <div className="social-icon google-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22.3 12.23c0-.79-.07-1.54-.2-2.28H12v4.51h5.68c-.25 1.3-.98 2.4-2.08 3.11v2.59h3.36c1.97-1.81 3.11-4.48 3.11-7.65l.23-.28z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.36-2.59c-.98.66-2.23 1.06-3.92 1.06-3.02 0-5.58-2.04-6.49-4.78H1.89v2.67C3.69 20.29 7.55 23 12 23z" fill="#34A853"/>
                <path d="M5.51 14.03c-.22-.66-.35-1.36-.35-2.03s.13-1.37.35-2.03V7.3H1.89C1.31 8.46 1 9.68 1 11s.31 2.54.89 3.7l3.62-2.67z" fill="#FBBC05"/>
                <path d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.45 1.19 14.97 0 12 0 7.55 0 3.69 2.71 1.89 6.7l3.62 2.67C6.42 6.79 8.98 4.75 12 4.75z" fill="#EB4335"/>
              </svg>
            </div>
            <span>{isLogin ? 'Continue with Google' : 'Sign up with Google'}</span>
          </button>

          <button 
            className="social-button twitter"
            onClick={() => handleSocialLogin('Twitter')}
          >
            <div className="social-icon twitter-icon">
              <svg width="28" height="23" viewBox="0 0 28 23" fill="none">
                <path d="M25.1 2.54c-.93.42-1.94.7-2.99.83 1.08-.64 1.9-1.66 2.29-2.87-.1 0-.02 0-.12.07-.98.58-2.07 1-3.23 1.22-.93-.99-2.25-1.61-3.71-1.61-2.81 0-5.09 2.28-5.09 5.09 0 .4.04.79.13 1.16-4.23-.21-7.98-2.24-10.49-5.32-.44.75-.69 1.62-.69 2.55 0 1.77.9 3.33 2.27 4.24-.84-.03-1.62-.26-2.31-.64v.06c0 2.47 1.76 4.53 4.08 4.99-.43.12-.88.18-1.34.18-.33 0-.65-.03-.96-.09.65 2.03 2.54 3.51 4.78 3.55-1.75 1.37-3.95 2.19-6.35 2.19-.41 0-.82-.02-1.22-.07 2.26 1.45 4.94 2.3 7.83 2.3 9.4 0 14.54-7.78 14.54-14.54 0-.22 0-.44-.01-.66 1-.72 1.86-1.62 2.55-2.64-.02.01-.05.02-.07.03z" fill="#47ACDF"/>
              </svg>
            </div>
            <span>{isLogin ? 'Continue with Twitter' : 'Sign up with Twitter'}</span>
          </button>
        </div>

        <div className="divider">
          <div className="divider-line"></div>
          <span className="divider-text">OR</span>
          <div className="divider-line"></div>
        </div>

        <div className="form-section">
          <h2 className="form-title">
            {isLogin ? 'Log in with your email address' : 'Sign up with your email address'}
          </h2>
          
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-fields">
              <div className="field-group">
                <label htmlFor="email" className="field-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email address"
                  className="field-input"
                  required
                />
              </div>

              <div className="field-group">
                <div className="password-label-row">
                  <label htmlFor="password" className="field-label">Password</label>
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      {showPassword ? (
                        <path d="M9.9 4.24C10.5 4.07 11.2 4 12 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22m-5.06-5.06A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.5 18.5 0 015.06-5.94l11.88 11.88z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      ) : (
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      )}
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    <span>{showPassword ? 'Hide' : 'Show'}</span>
                  </button>
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter your password"
                  className="field-input"
                  required
                />
                {!isLogin && (
                  <p className="password-hint">
                    Use 8 or more characters with a mix of letters, numbers & symbols
                  </p>
                )}
              </div>
            </div>

            {!isLogin && (
              <div className="agreement-section">
                <div className="terms-checkbox">
                  <input
                    type="checkbox"
                    id="terms"
                    checked={agreeToTerms}
                    onChange={(e) => setAgreeToTerms(e.target.checked)}
                    className="checkbox-input"
                  />
                  <label htmlFor="terms" className="checkbox-label">
                    By creating an account, you agree to the <a href="#" className="link">Terms of use</a> and <a href="#" className="link">Privacy Policy</a>.
                  </label>
                </div>

                <div className="recaptcha-section">
                  <div className="recaptcha-checkbox">
                    <input
                      type="checkbox"
                      id="recaptcha"
                      checked={isNotRobot}
                      onChange={(e) => setIsNotRobot(e.target.checked)}
                      className="checkbox-input"
                    />
                    <label htmlFor="recaptcha" className="recaptcha-label">
                      I'm not a robot
                    </label>
                  </div>
                  <div className="recaptcha-logo">
                    <svg width="48" height="46" viewBox="0 0 48 46" fill="none">
                      <path d="M39.6 0H32.4C31.3 0 30.4 0.9 30.4 2V14H26.4V2C26.4 0.9 25.5 0 24.4 0H17.2C16.1 0 15.2 0.9 15.2 2V14H11.2V2C11.2 0.9 10.3 0 9.2 0H2C0.9 0 0 0.9 0 2V44C0 45.1 0.9 46 2 46H46C47.1 46 48 45.1 48 44V2C48 0.9 47.1 0 46 0H39.6Z" fill="#1C3AA9"/>
                      <path d="M18.5 0H29.3C30.4 0 31.3 0.9 31.3 2V14.5H16.4V2C16.4 0.9 17.3 0 18.5 0Z" fill="#4285F4"/>
                      <path d="M15.6 16.16H36.3V32.28H15.6V16.16Z" fill="#ABABAB"/>
                      <path d="M0 38.54H48V46.16H0V38.54Z" fill="#A6A6A6"/>
                    </svg>
                  </div>
                </div>
              </div>
            )}

            <div className="submit-section">
              <button 
                type="submit" 
                className={`submit-button ${(!isLogin && (!agreeToTerms || !isNotRobot)) ? 'disabled' : ''}`}
                disabled={isLoading || (!isLogin && (!agreeToTerms || !isNotRobot))}
              >
                {isLoading ? (
                  <div className="loading-spinner"></div>
                ) : (
                  isLogin ? 'Log in' : 'Sign up'
                )}
              </button>

              <button 
                type="button" 
                className="toggle-auth-mode"
                onClick={() => setIsLogin(!isLogin)}
              >
                {isLogin 
                  ? "Don't have an account? Sign up" 
                  : "Already have an account? Log in"
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginSignup; 